import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Fule from "./images/fuleIcon.svg";

const RegCarDetailCard = ({
    heading,
    label,
    engineType,
    // edit = true,
    id,
    clickHandler = () => {}
}) => {

    const onClickHandler = (selectedBrand) => {
        clickHandler(selectedBrand);
    };
    return (
        <div>
            <span styleName={"styles.heading"}>{heading}</span>
            <div
                styleName={`${heading === "Car Owner" ? "styles.greyCard" : "styles.cardWrap"}`}
                onClick={() => onClickHandler({
                    heading,
                    displayText: label,
                    id
                })}>
                <strong styleName={"styles.label"}>{label}</strong>
                {engineType &&
                    <small styleName={"styles.variant"}>
                        <img src={Fule} alt="fule"/>
                        {engineType}</small>
                }
            </div>
            {/* {edit &&
            <span role="button" styleName={"styles.edit"} onClick={() => onClickHandler({
                heading,
                displayText: label,
                id
            })}>Edit</span>
            } */}
        </div>
    );
};
RegCarDetailCard.propTypes = {
    heading: PropTypes.string,
    label: PropTypes.string,
    engineType: PropTypes.string,
    // edit: PropTypes.bool,
    id: PropTypes.string,
    clickHandler: PropTypes.func
};
export default RegCarDetailCard;
